import { createStore, applyMiddleware } from 'redux'
import { createLogger } from 'redux-logger'
import createSagaMiddleware from 'redux-saga'
import { connectRouter, routerMiddleware } from 'connected-react-router'
import { composeWithDevTools } from 'redux-devtools-extension'
import Raven from 'raven-js'
import createRavenMiddleware from 'raven-for-redux'
import createHistory from 'history/createBrowserHistory'
import rootReducer from './reducers'
import rootSaga from './sagas'
import settings from '../libs/settings'

const isModeDevelopment = !settings.isProduction
const isModeProduction = settings.isProduction
let middlewares = []

export const history = createHistory()
const historyMiddleware = routerMiddleware(history)
const sagaMiddleware = createSagaMiddleware()

middlewares = [...middlewares, historyMiddleware, sagaMiddleware]

// Note: logger must be the last middleware in chain, otherwise it will log thunk and promise, not actual actions
if (isModeDevelopment) {
  middlewares = [...middlewares,
    (createLogger({
      collapsed: true
    }))
  ]
}

if (isModeProduction) {
  middlewares = [createRavenMiddleware(Raven), ...middlewares]
}

export const store = createStore(
  connectRouter(history)(rootReducer),
  isModeDevelopment
    ? composeWithDevTools(applyMiddleware(...middlewares))
    : applyMiddleware(...middlewares)
)

sagaMiddleware.run(rootSaga)
